import { useState, useEffect } from 'react';

import NudosRadioButton from '../../../NudosRadioButton/NudosRadioButton';
import { ISortFilter, SORT_ORDER } from '../../../../types/global';
import './Sort.scss';

export interface ISortProps {
  onSortChange: (sortFilter: ISortFilter) => void;
  showReferenceLetters?: boolean;
  customSortClassName?: string;
  currentSortFilter?: ISortFilter;
}

/**
 * Componente para manejar el ordenamiento ascendente/descendente
 * @param {ISortProps} props - Props del componente
 * @param {Function} props.onSortChange - Función que se ejecuta cuando cambia la selección del ordenamiento
 * @param {ISortFilter} props.currentSortFilter - Valor actual del filtro de ordenamiento (opcional)
 */
const Sort = ({ onSortChange, showReferenceLetters, customSortClassName = '', currentSortFilter }: ISortProps) => {
  const [selectedSort, setSelectedSort] = useState<ISortFilter>(currentSortFilter || { value: SORT_ORDER.DESC });

  const handleSortChange = (sortFilter: ISortFilter) => {
    setSelectedSort(sortFilter);
    onSortChange(sortFilter);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (currentSortFilter) {
      setSelectedSort(currentSortFilter);
    }
  }, [currentSortFilter]);

  return (
    <div className={`moduleSort ${customSortClassName}`} onClick={handleClick}>
      <div className="sortTitle">Orden:</div>
      <div className="sortOptions" onClick={handleClick}>
        <div className="sortOption" onClick={handleClick}>
          <div className="sortOptionContent" onClick={handleClick}>
            <span>{showReferenceLetters ? 'Ascendente (A-Z)' : 'Ascendente'}</span>
            <NudosRadioButton
              isButtonActive={selectedSort.value === SORT_ORDER.ASC}
              handleClickButton={() => handleSortChange({ value: SORT_ORDER.ASC })}
              componentSize="small"
            />
          </div>
        </div>
        <div className="sortOption" onClick={handleClick}>
          <div className="sortOptionContent" onClick={handleClick}>
            <span>{showReferenceLetters ? 'Descendente (Z-A)' : 'Descendente'}</span>
            <NudosRadioButton
              isButtonActive={selectedSort.value === SORT_ORDER.DESC}
              handleClickButton={() => handleSortChange({ value: SORT_ORDER.DESC })}
              componentSize="small"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sort;
